import { render, staticRenderFns } from "./student_layout.vue?vue&type=template&id=9d880cba&scoped=true&"
import script from "./student_layout.vue?vue&type=script&lang=js&"
export * from "./student_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d880cba",
  null
  
)

export default component.exports